import * as React from 'react'

function TwitterMinimalSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M11.9834 7.28317L12.0355 8.14102L11.1684 8.03598C8.01228 7.63331 5.25501 6.26775 2.91394 3.97432L1.76941 2.83635L1.47461 3.67669C0.850318 5.54996 1.24917 7.52827 2.54977 8.85881C3.24342 9.59411 3.08735 9.69916 1.8908 9.26148C1.47461 9.12142 1.11044 9.01638 1.07576 9.0689C0.954366 9.19145 1.37056 10.7846 1.70004 11.4149C2.15092 12.2902 3.07001 13.1481 4.0758 13.6558L4.92553 14.0584L3.91973 14.0759C2.94862 14.0759 2.91394 14.0935 3.01798 14.4611C3.36481 15.5991 4.73477 16.8071 6.26081 17.3323L7.33597 17.6999L6.39954 18.2602C5.01224 19.0655 3.38215 19.5207 1.75207 19.5557C0.971707 19.5732 0.330078 19.6432 0.330078 19.6957C0.330078 19.8708 2.44572 20.8512 3.67695 21.2364C7.37066 22.3743 11.758 21.8841 15.0529 19.9408C17.3939 18.5578 19.735 15.8092 20.8275 13.1481C21.4171 11.73 22.0067 9.13893 22.0067 7.89592C22.0067 7.09059 22.0588 6.98555 23.0299 6.02265C23.6021 5.46242 24.1397 4.84967 24.2438 4.6746C24.4172 4.34197 24.3998 4.34197 23.5154 4.63959C22.0414 5.1648 21.8333 5.09477 22.5617 4.30695C23.0992 3.74672 23.7409 2.73131 23.7409 2.43369C23.7409 2.38116 23.4807 2.4687 23.1859 2.62626C22.8738 2.80134 22.1801 3.06394 21.6599 3.22151L20.7235 3.51913L19.8738 2.94139C19.4055 2.62626 18.7466 2.27612 18.3997 2.17108C17.5153 1.92598 16.1627 1.96099 15.365 2.24111C13.1973 3.02893 11.8274 5.05976 11.9834 7.28317Z"
          fill={props.fill || '#111111'}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" transform="translate(0.330078 0.00717163)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const TwitterMinimal = React.memo(TwitterMinimalSvg)

function TwitterSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 20 17" {...props}>
      <g clipPath="url(#prefix__prefix__clip_twitter)">
        <path
          fill="#55ACEE"
          d="M9.711 4.397l.043.715-.722-.088c-2.63-.336-4.928-1.474-6.879-3.385L1.2.691l-.245.7c-.52 1.561-.188 3.21.896 4.319.578.612.448.7-.55.335-.346-.116-.65-.204-.679-.16-.1.102.246 1.43.52 1.955.376.73 1.142 1.444 1.98 1.867l.709.336-.839.014c-.809 0-.838.015-.751.321.289.949 1.43 1.955 2.702 2.393l.896.306-.78.467a8.148 8.148 0 01-3.873 1.08c-.65.014-1.185.073-1.185.117 0 .145 1.763.962 2.79 1.283 3.077.949 6.733.54 9.479-1.08 1.95-1.152 3.902-3.442 4.812-5.66.492-1.182.983-3.34.983-4.377 0-.67.043-.758.852-1.56.477-.468.925-.978 1.012-1.124.145-.277.13-.277-.607-.03-1.228.438-1.402.38-.795-.277.448-.466.983-1.313.983-1.56 0-.044-.217.029-.462.16-.26.146-.839.365-1.272.496l-.78.248-.709-.481c-.39-.263-.939-.555-1.228-.642-.737-.205-1.864-.175-2.529.058-1.806.656-2.948 2.349-2.818 4.202z"
        />
      </g>
      <defs>
        <clipPath id="prefix__prefix__clip_twitter">
          <path fill="#fff" d="M0 0h20v16.528H0V0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Twitter = React.memo(TwitterSvg)
